import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
// import GA4React from "ga-4-react";

// const ga4react = new GA4React("G-Z0TZ7TDHS1");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// (async () => {
//   await ga4react.initialize();

//   ReactDOM.render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>,
//     document.getElementById("root")
//   );
// })();
